import { socialPostsConstants } from '@constants/social-posts';

const initialState = {
    data: [],
    loading: true,
    error: '',
    totalCount: 0,
    pages: 1,
    latestRequestId: 0,
};

export function socialPosts(state = initialState, action) {
    switch (action.type) {
        case socialPostsConstants.SOCIAL_POSTS_FETCH:
            return { ...state, loading: true, error: '', latestRequestId: action.requestId };
        case socialPostsConstants.SOCIAL_POSTS_SUCCESS:
            if (action.requestId !== state.latestRequestId) return state;
            return {
                ...state,
                loading: false,
                data: action.data.items,
                totalCount: action.data.totalCount,
                pages: action.data.pages,
                error: '',
            };
        case socialPostsConstants.SOCIAL_POSTS_ERROR:
            if (action.requestId !== state.latestRequestId) return state;
            return { ...state, error: action.message, loading: false };
        case socialPostsConstants.RESET_SOCIAL_POSTS:
            return { ...state, data: [], totalCount: 0, pages: 1, loading: true, latestRequestId: action.requestId };
        case socialPostsConstants.SET_SOCIAL_POSTS:
            return { ...state, data: action.data };
        case socialPostsConstants.SOCIAL_POSTS_UPDATE_POST:
            return {
                ...state,
                data: state.data.map(campaign =>
                    campaign.posts?.some(post => post.id === action.post.id)
                        ? {
                              ...campaign,
                              posts: campaign.posts.map(post =>
                                  post.id === action.post.id ? { ...post, ...action.post } : post,
                              ),
                          }
                        : campaign,
                ),
            };
        default:
            return state;
    }
}
